import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@eb/eds-icon';
import { StatusDotChunky } from '@eb/eds-iconography';

import { EVENT_STATUS_INFO_SHAPE } from '../constants';
import {
    getFormattedStatusDate,
    getSalesStatusIconColor,
    getSalesStatusLabel,
    eventIsNotYetOnSale,
    eventIsScheduledPublish,
    shouldShowSalesStatusIcon,
} from './utils';

import './SalesStatusLabel.scss';

export default class SalesStatusLabel extends PureComponent {
    static propTypes = {
        statusInfo: EVENT_STATUS_INFO_SHAPE.isRequired,
    };

    _getStatusDate = () => {
        const {
            statusInfo: { eventSalesStatus, publishSettings, start = {} },
        } = this.props;
        let statusDate = null;
        let statusDateContent = null;

        const isScheduledPublish = eventIsScheduledPublish(publishSettings);
        const isNotYetOnSale = eventIsNotYetOnSale(eventSalesStatus);

        if (isScheduledPublish) {
            const { schedulePublishDate } = publishSettings;
            const { timezone } = start;

            statusDate = getFormattedStatusDate({
                utc: schedulePublishDate,
                timezone,
            });
        } else if (isNotYetOnSale) {
            const { startSalesDate: { utc, timezone } = {} } = eventSalesStatus;

            statusDate = getFormattedStatusDate({ utc, timezone });
        }

        if (statusDate) {
            statusDateContent = (
                <span
                    className="eds-l-pad-left-1 eds-l-sw-pad-left-0 eds-l-sm-pad-left-0 eds-l-sn-pad-left-0"
                    data-spec="sales-status-date"
                >
                    {statusDate}
                </span>
            );
        }

        return statusDateContent;
    };

    render() {
        const {
            statusInfo: { status, eventSalesStatus, publishSettings },
        } = this.props;
        const isScheduledPublish = eventIsScheduledPublish(publishSettings);
        const label = getSalesStatusLabel({
            status,
            isScheduledPublish,
            ...eventSalesStatus,
        });
        const statusDate = this._getStatusDate();
        let icon;

        if (
            shouldShowSalesStatusIcon({
                isScheduledPublish,
                eventSalesStatus,
                eventStatus: status,
            })
        ) {
            icon = (
                <Icon
                    type={<StatusDotChunky />}
                    color={getSalesStatusIconColor({
                        isScheduledPublish,
                        status,
                        salesStatus:
                            eventSalesStatus && eventSalesStatus.salesStatus,
                    })}
                />
            );
        }

        return (
            <div className="sales-status eds-l-pad-right-2 eds-show-down-ln">
                <span
                    className="eds-text-color--grey-900"
                    data-spec="sales-status-label"
                >
                    {icon}
                    {label}
                </span>
                {statusDate}
            </div>
        );
    }
}
